import _ from 'lodash';
import React from 'react';
import SimpleKeyValueField from './SimpleKeyValueField';
import {Typography} from '@mui/material';

interface MultiKeyValueFieldProps {
  fields: {
    name: string;
    path: string;
    style?: React.CSSProperties;
    parseReadValue?: (value: any) => any;
  }[];
  data: any;
  loading?: boolean;
}

const MultiKeyValueField = ({
  fields,
  data,
  loading = false,
}: MultiKeyValueFieldProps) => {
  return (
    <>
      {fields.map((field) => {
        let value = _.get(data, field.path);

        if (field.parseReadValue) {
          value = field.parseReadValue(value);
        }

        if (
          typeof value === 'object' &&
          value != null &&
          !Array.isArray(value)
        ) {
          return (
            <div style={field.style}>
              <Typography>{field.name}</Typography>
              <div>
                {Object.entries(value).map(([key, val]) => {
                  return (
                    <SimpleKeyValueField
                      key={key}
                      name={key}
                      value={val}
                      loading={loading}
                    />
                  );
                })}
              </div>
            </div>
          );
        }
        return (
          <SimpleKeyValueField
            key={field.path}
            name={field.name}
            value={value}
            style={field.style}
            loading={loading}
          />
        );
      })}
    </>
  );
};

export default MultiKeyValueField;
